document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('CollectionInfiniteRoot');
  if (!root) return;

  const grid = root.querySelector('[data-product-grid]');
  const pagination = root.querySelector('[data-pagination]');
  const sectionId = root.getAttribute('data-section-id');

  if (!grid || !pagination || !sectionId) return;

  let loading = false;
  let nextUrl = getNextUrl();

  if (!nextUrl) return;

  const sentinel = document.createElement('div');
  sentinel.id = 'CollectionInfiniteSentinel';
  sentinel.style.height = '1px';
  sentinel.setAttribute('aria-hidden', 'true');
  root.appendChild(sentinel);

  const observer = new IntersectionObserver(async function (entries) {
    const entry = entries[0];
    if (!entry.isIntersecting || loading || !nextUrl) return;

    loading = true;

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Failed to load next page');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextRoot = doc.getElementById('CollectionInfiniteRoot');
      if (!nextRoot) throw new Error('Missing next root');

      const nextGrid = nextRoot.querySelector('[data-product-grid]');
      const nextPagination = nextRoot.querySelector('[data-pagination]');

      if (!nextGrid) throw new Error('Missing next grid');

      const newItems = Array.from(nextGrid.children);

      prepareImages(newItems);

      newItems.forEach(function (item) {
        item.classList.add('aos-animate');
        grid.appendChild(item);
      });

      if (window.AOS) {
        AOS.refresh();
      }

      if (nextPagination) {
        pagination.innerHTML = nextPagination.innerHTML;
      } else {
        pagination.innerHTML = '';
      }

      nextUrl = getNextUrl();

      if (!nextUrl) {
        observer.disconnect();
        sentinel.remove();
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
      observer.disconnect();
    } finally {
      loading = false;
    }
  }, {
    rootMargin: '400px 0px'
  });

  observer.observe(sentinel);

  function getNextUrl() {
    // First try the standard rel="next" link
    const relNext = pagination.querySelector('a[rel="next"]');
    if (relNext) return relNext.href;

    // Fallback for themes whose pagination links have no rel attribute
    // (like Impulse's default pagination snippet).
    // Strategy: find the current page number from the active/current span,
    // then find a link whose page= param is exactly current + 1.
    // This is precise — it won't pick up "previous" links or loop on last page.
    const currentSpan = pagination.querySelector('.page.current, .current, [aria-current="page"]');
    if (!currentSpan) return null;

    const currentPage = parseInt(currentSpan.textContent.trim(), 10);
    if (isNaN(currentPage)) return null;

    const nextPage = currentPage + 1;
    const allLinks = Array.from(pagination.querySelectorAll('a[href]'));

    const nextLink = allLinks.find(function (a) {
      try {
        const params = new URL(a.href, window.location.origin).searchParams;
        return parseInt(params.get('page'), 10) === nextPage;
      } catch (e) {
        return false;
      }
    });

    return nextLink ? nextLink.href : null;
  }

  function prepareImages(items) {
    items.forEach(function (item) {

      item.querySelectorAll('img[data-src]').forEach(function (img) {
        var dataSrc = img.getAttribute('data-src');
        if (!dataSrc) return;

        img.classList.remove('lazyload');
        img.classList.add('lazyloaded');
        img.setAttribute('src', dataSrc);

        var widthsAttr = img.getAttribute('data-widths');
        if (widthsAttr) {
          try {
            var widths = JSON.parse(widthsAttr);
            var srcset = widths.map(function (w) {
              return dataSrc.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
            }).join(', ');
            img.setAttribute('srcset', srcset);
            img.setAttribute('sizes', '(max-width: 767px) 50vw, 25vw');
          } catch (e) {}
        }

        img.removeAttribute('data-src');
        img.removeAttribute('data-widths');
        img.removeAttribute('data-sizes');
        img.removeAttribute('data-aspectratio');
      });

      item.querySelectorAll('[data-bgset]').forEach(function (el) {
        var bgset = el.getAttribute('data-bgset');
        if (!bgset) return;

        var imageUrl = bgset.split(',')[0].trim().split(' ')[0];
        if (imageUrl.indexOf('//') === 0) {
          imageUrl = window.location.protocol + imageUrl;
        }

        el.style.backgroundImage = 'url("' + imageUrl + '")';
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = 'center center';
        el.style.backgroundRepeat = 'no-repeat';
        el.classList.remove('lazyload');
        el.classList.add('lazyloaded');
        el.removeAttribute('data-bgset');
      });
    });
  }
});